// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__nuK9O","spin":"spinner_spin__WJDJq"};